import { Badge } from '@/components/ui/badge';
import { DocumentStatus } from '../types';

interface MrsDocumentStatusBadgeProps {
  status: DocumentStatus;
}

const statusConfig: Record<
  DocumentStatus,
  { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }
> = {
  [DocumentStatus.Draft]: {
    label: 'Draft',
    variant: 'outline',
  },
  [DocumentStatus.Open]: {
    label: 'Open',
    variant: 'outline',
  },
  [DocumentStatus.Closed]: {
    label: 'Served',
    variant: 'default',
  },
  [DocumentStatus.Cancelled]: {
    label: 'Cancelled',
    variant: 'destructive',
  },
};

export function MrsDocumentStatusBadge({ status }: MrsDocumentStatusBadgeProps) {
  const config = statusConfig[status] ?? {
    label: 'Unknown',
    variant: 'outline' as const,
  };

  return <Badge variant={config.variant}>{config.label}</Badge>;
}
